import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {ToastrService} from "ngx-toastr";
import {NgxSpinnerService} from "ngx-spinner";
import { LogService } from '../../../services/log.service';
@Component({
    selector: 'app-add-card-verification-error',
    templateUrl: './add-card-verification-error.component.html',
    styleUrls: ['./add-card-verification-error.component.scss'],
    standalone: false
})
export class AddCardVerificationErrorComponent implements OnInit {

  constructor(private router: Router,private toastr: ToastrService,private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.spinner.show();
    const redirectURL = localStorage.getItem('managecard')
    LogService.debug(redirectURL);
    this.toastr.error('Det ser ikke ut som om du er eier av kortet', 'Legg til nytt');
    if(redirectURL){
      localStorage.setItem('add-card','verification-error');
      this.router.navigateByUrl(redirectURL);
    }
    else{
      this.router.navigateByUrl('https://minside.nabonett.no');
    }
  }

}
